// @flow

import React from 'react';
import { Icon } from 'semantic-ui-react';

import { StyledButton } from '../../../common-utils/styledComponents';

export const UploadButton = ({ disabled, onClick, floated = 'right', size = 'mini' }) => (
  <StyledButton
    compact={true}
    data-testid="upload-button"
    disabled={disabled}
    floated={floated}
    icon={<Icon name="upload" />}
    onClick={onClick}
    primary={true}
    size={size}
    type="button"
  />
);
